var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "drag-drop" }, [
    this.dragActive
      ? _c(
          "div",
          {
            ref: "dropzone",
            staticClass: "dropzone-container",
            class: { "dropzone-call": this.call },
            on: { dragleave: _vm.dragleave, drop: _vm.drop },
          },
          [
            _c("input", {
              ref: "file",
              staticClass: "hidden-input",
              attrs: {
                type: "file",
                multiple: "",
                name: "file",
                id: "fileInput",
                accept: ".pdf,.jpg,.jpeg,.png,.txt",
              },
              on: { change: _vm.onChange },
            }),
            _c(
              "label",
              {
                staticClass: "file-label",
                attrs: { for: "fileInput", "aria-live": "assertive" },
              },
              [
                !_vm.isMobile()
                  ? _c("div", { staticClass: "main-text-container" }, [
                      _c("span", { staticClass: "main-text" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$gettext("Arrastra y suelta archivos aquí.")
                          )
                        ),
                      ]),
                      _c("div", { staticClass: "tooltip-info" }, [
                        _vm._v(" " + _vm._s(_vm.$gettext("O")) + " "),
                        _c(
                          "label",
                          {
                            attrs: {
                              for: "fileInput",
                              tabindex: "0",
                              role: "button",
                            },
                            on: {
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.$refs.file.click()
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "space",
                                      32,
                                      $event.key,
                                      [" ", "Spacebar"]
                                    )
                                  )
                                    return null
                                  $event.preventDefault()
                                  return _vm.$refs.file.click()
                                },
                              ],
                            },
                          },
                          [
                            _c(
                              "span",
                              { staticClass: "secondary-text clickable" },
                              [_vm._v(_vm._s(_vm.$gettext("busca archivos")))]
                            ),
                          ]
                        ),
                        _c("span", { staticStyle: { "font-weight": "100" } }, [
                          _vm._v("(máx. 5mb)"),
                        ]),
                        _c("span", {
                          staticClass: "icon-info",
                          attrs: {
                            title: _vm.$gettext(
                              "Tipos de archivos permitidos: jpg, png, jpeg, pdf y txt."
                            ),
                          },
                        }),
                      ]),
                    ])
                  : _c("div", [
                      _c(
                        "span",
                        { staticClass: "main-text", attrs: { tabindex: "0" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$gettext("Pulsa aqui para añadir archivos")
                            )
                          ),
                        ]
                      ),
                    ]),
              ]
            ),
            _c("div", { staticClass: "drop-files-container" }, [
              _vm.files.length
                ? _c(
                    "div",
                    { staticClass: "preview-container" },
                    _vm._l(_vm.files, function (file, index) {
                      return _c(
                        "div",
                        { key: file.name, staticClass: "preview-card" },
                        [
                          _c("div", { staticClass: "img-container" }, [
                            _c("input", {
                              staticClass: "delete-img",
                              attrs: { type: "checkbox", tabindex: "0" },
                              domProps: {
                                checked: _vm.selectedFiles.includes(file),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectImageToDelete(file)
                                },
                              },
                            }),
                            file.type == "application/pdf"
                              ? _c("img", {
                                  attrs: {
                                    src: require("../assets/images/pdfico.png"),
                                  },
                                })
                              : _c("img", {
                                  staticClass: "preview-img",
                                  attrs: { src: _vm.generateThumbnail(file) },
                                }),
                          ]),
                          _c("div", { staticClass: "card-footer" }, [
                            _c(
                              "p",
                              {
                                staticClass: "preview-text-img",
                                attrs: { title: file.name, tabindex: "0" },
                              },
                              [_vm._v(_vm._s(_vm.makeName(file.name)))]
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  )
                : !_vm.files.length && !_vm.isMobile()
                ? _c("div", { staticClass: "empty-preview-container" }, [
                    _c("span", [_vm._v("Drop your files here")]),
                  ])
                : _vm._e(),
            ]),
            _c("div", { staticClass: "file-footer-buttons" }, [
              _c(
                "button",
                {
                  staticClass: "close-drag",
                  attrs: { tabindex: "0", name: "closeDrag" },
                  on: { click: _vm.close },
                },
                [_vm._v(_vm._s(_vm.$gettext("Cancelar")))]
              ),
              _vm.selectedFiles.length
                ? _c(
                    "button",
                    {
                      staticClass: "delete-selected",
                      attrs: { tabindex: "0", name: "deleteSelectedFiles" },
                      on: { click: _vm.deleteSelectedFiles },
                    },
                    [
                      _c("div", { staticClass: "thrash-icon" }),
                      _vm._v(_vm._s(_vm.$gettext("Eliminar archivos"))),
                    ]
                  )
                : _c(
                    "button",
                    {
                      staticClass: "sendButton",
                      class: { disabled: _vm.files.length == 0 },
                      attrs: {
                        tabindex: "0",
                        disabled: _vm.files.length == 0,
                        name: "sendFiles",
                      },
                      on: { click: _vm.uploadFiles },
                    },
                    [_vm._v(_vm._s(_vm.$gettext("Enviar archivos")))]
                  ),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }